import 'firebase/messaging';
import React, { useEffect, useState } from "react";
import ReactGA from 'react-ga';
import "./App.scss";
import "./app/views/pages/Home/Content/Dashboard/style.scss";
import "./app/views/pages/Home/Content/Notifications/style.scss";
import "./app/views/pages/Home/Content/Profile/style.scss";
import "./app/views/pages/Home/Content/content.scss";
import "./app/views/pages/Home/home.scss";
import "./app/views/pages/Landing/landing.scss";
import "./app/views/pages/User/user.scss";

import { message, Spin } from 'antd';
import PrivateRoute from "app/common/HOC/PrivateRoute";
import PopUpMessage from 'app/common/components/PopUpMessage';
import RoleRoute from 'app/common/HOC/RoleRoute';
import { googleAnalyticsFn } from 'app/common/components/googleAnalyticsFn';
import APP_ROUTES from "app/constants/routes/app";
import { completedJobsList, getJobType } from 'app/description/jobs.description';
import history from "app/history";
import { getQueryParams } from 'app/hooks/useCustomNavigation';
import { setActionItem, setFiscalYear, setNotificationMessage } from 'app/store/state/home/action';
import { getJobId, setJobStatus, setPopUpMessageData, setQuickLinksData, setSingleJobDetails } from 'app/store/state/jobs/action';
import { getJobDatApi } from 'app/store/state/jobs/api';
import { currentFiscalYear } from 'app/utils/fiscalYear';
import { include } from 'app/utils/javascript';
import { getItem, removeItem, setLoginSession } from "app/utils/session";
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Router, Switch } from "react-router";
import { getToken, } from "./firebase";
import { generateLoginAuth } from 'app/requests';
import { SALES_DEPARTMENT, SALES_DEPARTMENT_USER, SALES_OFFICE, SALES_OFFICE_USER } from 'app/utils/config';

const PrivacyPolicy = React.lazy(() => import("app/common/components/PrivacyPolicy"));
const LandingPage = React.lazy(() => import("app/views/pages/Landing"));
const LoginPage = React.lazy(() => import("app/views/pages/User/Login"));
const HomePage = React.lazy(() => import("app/views/pages/Home"));
const PasswordPage = React.lazy(() => import("app/views/pages/User/Password"));
const ResetPassword = React.lazy(() => import("app/views/pages/User/Password/ResetPassword"));
const newUIPage = React.lazy(() => import("app/views/pages/Landing/NewUI/index"));
const LandingPageUI = React.lazy(() => import('app/views/pages/Landing/landingUI'));

ReactGA.initialize('UA-183758480-1', {
    debug: false,
    titleCase: false,
    redactEmail: false
});

function App() {
    const { t } = useTranslation();
    const [isTokenFound, setTokenFound] = useState(false);
    const modalOpenClass = useSelector(state => state.admin.modalOpenClass)
    const notificationMessage = useSelector(state => state.home.notificationMessage)
    const entity = useSelector(state => state.home.entity)
    const dispatch = useDispatch();
    const authToken = getItem("token");
    const fiscalYearLocal = getItem("fiscalYear");
    const user_data = getItem("user_data")
    const userId = user_data ? JSON.parse(user_data)?.id : ""
    const jobId = getQueryParams('jobId')
    const msgValue = useSelector((state) => state.jobs.messageData)
    const [loadingFlag, setLoadingFlag] = useState(false)
    const search = window.location.search;
    const name = new URLSearchParams(search).get("name");
    const externalUserId = new URLSearchParams(search).get("userId");
    const clientId = new URLSearchParams(search).get("clientId");

    // const isTokenExpired = (token) => {
    //     const expirationTime = JSON.parse(atob(token.split('.')[1])).exp; // get the expiration time from the token payload
    //     return Date.now() >= expirationTime * 1000; // multiply by 1000 to convert from seconds to milliseconds
    // }
    // useEffect(() => {
    //     if (isTokenExpired(token)) {
    //         console.log("Token is expired");

    //     } else {
    //         console.log("Token is not expired");
    //     }
    // }, [])

    useEffect(() => {
        window.redux = dispatch
    }, [dispatch])

    useEffect(() => {
        getToken(setTokenFound);
        googleAnalyticsFn("Home Page")
    })

    useEffect(() => {
        if ([/* "HOME", "JOB_VIEW", */ "REPORT", "REPORT_VIEW", "ISSUE_MANAGEMENT"].includes(entity)) {
            dispatch(setFiscalYear(currentFiscalYear))
        } else if (["JOB_VIEW"].includes(entity)) {
            dispatch(setFiscalYear(fiscalYearLocal ? fiscalYearLocal : currentFiscalYear))
        }
    }, [entity])

    useEffect(() => {
        if (name) {
            const temp = name.split('/')
            if (temp[0] === "CYLINDER") {
                dispatch(setActionItem("VIEW_LIST_CYLINDER", "VIEW"));
            } else if (temp[0] === "JOB") {
                dispatch(setActionItem("JOB_VIEW", "VIEW"));
            } else if (temp[0] === "USER" || temp[0] === "BUILDING") {
                dispatch(setActionItem("ADMIN", "VIEW"));
            }
        }
    }, [name])

    useEffect(() => {
        if (modalOpenClass) {
            document.body.classList.add("modal-open")
        }
        else {
            document.body.classList.remove("modal-open")
        }
    }, [modalOpenClass])

    useEffect(() => {
        if (notificationMessage && notificationMessage?.type && notificationMessage?.message) {
            message[notificationMessage?.type](/\s/.test(notificationMessage?.message) ? notificationMessage?.message : t(notificationMessage?.message));
            dispatch(setNotificationMessage({ type: "", message: "" }))
        }
    }, [notificationMessage])

    useEffect(() => {
        if (authToken && userId) {
            if (jobId) {
                getJobData()
            } else {
                !getItem("jobRedirection") && window.location.pathname !== APP_ROUTES.ACCOUNT_HIERARCHY_PERFORMANCE && history.push(APP_ROUTES.HOME)
            }
        }
    }, [authToken, jobId])

    useEffect(() => {
        if (externalUserId && clientId) {
            const credentials = {
                externalUserId,
                clientId
            }
            setLoadingFlag(true)
            generateLoginAuth(credentials, setLoadingFlag).then((res) => {
                setLoginSession(res)
                dispatch(setActionItem("", "HOME"));
            })
        }
    }, [externalUserId, clientId])

    const getJobData = async () => {
        const response = await getJobDatApi({ payload: { authToken: authToken, jobId: getQueryParams('jobId') } })
        const errorMsg = get(response, "data.error.errorMsg");

        if (response?.data) {
            if (response?.data?.data) {
                const data = response?.data?.data;
                dispatch(setSingleJobDetails(data || {}));
                dispatch(getJobId(data?.jobId));
                const jobs = getJobType({ jobType: data?.jobType })
                dispatch(setActionItem("JOB_VIEW", "VIEW"));
                dispatch(setQuickLinksData(jobs?.selectedJobType))
                dispatch(setJobStatus(include(completedJobsList, data?.status) ? "Completed" : "Active"))
            } else {
                dispatch(setPopUpMessageData({ modal: true, message: [errorMsg] }))
                history.push(APP_ROUTES.HOME)
            }
            if (getItem("jobRedirection")) {
                removeItem("jobRedirection")
            }
        }
    }

    if (loadingFlag) return <div className="cylinder-loader">
        <Spin tip={t("loading")} />
    </div>

    if(externalUserId && clientId && !authToken) return null

    return (
        <>
            <Router history={history}>
                <Switch>
                    <Route
                        exact
                        path={APP_ROUTES.LANDING}
                        component={LandingPage}
                    />
                    <Route
                        exact
                        path={APP_ROUTES.NEW_LANDING}
                        component={LandingPageUI}
                    />
                    <Route
                        exact
                        path={APP_ROUTES.LOGIN}
                        component={LoginPage}
                    />
                    <Route
                        exact
                        path={APP_ROUTES.PASSWORD}
                        component={PasswordPage}
                    />
                    <Route
                        // exact
                        path={APP_ROUTES.FORGOT_PASSWORD}
                        component={ResetPassword}
                    />
                    <Route
                        exact
                        path={APP_ROUTES.NEW_DESIGN}
                        component={newUIPage}
                    />
                    <PrivateRoute
                        exact
                        path={APP_ROUTES.HOME}
                        component={HomePage}
                    />
                    <PrivateRoute
                        path={APP_ROUTES.JOBS}
                        component={HomePage}
                    // component={JobViewList}
                    />
                    <RoleRoute exact path={APP_ROUTES.ACCOUNT_HIERARCHY_PERFORMANCE} component={HomePage} allowedRoles={[SALES_DEPARTMENT, SALES_DEPARTMENT_USER, SALES_OFFICE, SALES_OFFICE_USER]} />
                    <Route
                        exact
                        path={APP_ROUTES.PRIVACY_POLICY}
                        component={PrivacyPolicy}
                    />

                    <Route
                        path="*"
                        component={() => <>No Routes Found</>}
                    />
                </Switch>
            </Router>
            {msgValue?.modal && <PopUpMessage {...{
                t, footer: !!msgValue?.onlyOkBtnFooter
            }} />
            }
        </>
    );
}

export default App;

